import { render, staticRenderFns } from "./ApuracaoAcaoListNivel1.vue?vue&type=template&id=efe96732&"
import script from "./ApuracaoAcaoListNivel1.vue?vue&type=script&lang=js&"
export * from "./ApuracaoAcaoListNivel1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports